module.exports = __webpack_public_path__ + "static/approach-96123cc15d9d498e4c738054629c028c.jpg";